let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7snhF"), load("bAoKR"), load("X0Jic"), load("96wGb")]).then(() => parcelRequire('H1FjW'));